import { Link } from 'react-router-dom';
import { CopyIdButton } from '@/components/shared';

export function DetailRow({
  label,
  value,
  copyValue,
  copyLabel,
  href,
  linkLabel,
}: {
  label: string;
  value: string;
  copyValue?: string;
  copyLabel?: string;
  href?: string;
  linkLabel?: string;
}) {
  const isExternalHref = href ? /^https?:\/\//.test(href) : false;
  const content =
    href && isExternalHref ? (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        aria-label={linkLabel}
        className="focus-ring min-w-0 rounded-sm font-medium text-neutral-900 hover:text-backoffice-600"
      >
        {value}
      </a>
    ) : href ? (
      <Link
        to={href}
        aria-label={linkLabel}
        className="focus-ring min-w-0 rounded-sm font-medium text-neutral-900 hover:text-backoffice-600"
      >
        {value}
      </Link>
    ) : (
      <span className="min-w-0 truncate">{value}</span>
    );

  return (
    <div className="grid gap-1 border-b border-neutral-100 py-3 last:border-b-0 sm:grid-cols-[9.5rem_minmax(0,1fr)] sm:gap-4">
      <dt className="font-semibold text-neutral-900">{label}</dt>
      <dd className="min-w-0 text-neutral-700">
        {copyValue && copyLabel ? (
          <div className="group inline-flex min-w-0 items-center gap-2">
            {content}
            <CopyIdButton value={copyValue} label={copyLabel} />
          </div>
        ) : (
          content
        )}
      </dd>
    </div>
  );
}
